import { PageProvider } from "../PageProvider";
import { ApiClientFactory } from "./clients";

export class PageProviderFactory {
  private readonly apiClientFactory: ApiClientFactory;

  constructor(baseUrl: string) {
    this.apiClientFactory = new ApiClientFactory(`${baseUrl}/api/v1/page`);
  }

  createPageProvider(): PageProvider {
    return new PageProvider(this.apiClientFactory.createApiClient());
  }
}
